import { useSelector } from 'react-redux';
import decode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Centralized authentication hook
export default function useAuth() {
  const authToken = useSelector((state) => state?.auth?.loginDetails?.data?.token || null);
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (authToken) {
      try {
        const decoded = decode(authToken);
        setUser(decoded);
        setIsAuthenticated(true);
      } catch (e) {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        history.push('/login');
      }
    } else {
      setUser(null);
      setIsAuthenticated(false);
    }
  }, [authToken, history]);

  return { user, isAuthenticated };
}
